var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9585 3.49774C5.83113 4.23843 5.43095 4.90441 4.83696 5.36421C4.24297 5.82402 3.49833 6.04423 2.75004 5.98139C2.00176 5.91854 1.3042 5.5772 0.795079 5.02475C0.285955 4.47229 0.00226144 3.74888 1.2501e-06 2.9973C-0.000685492 2.24394 0.281597 1.51785 0.790842 0.963089C1.30009 0.408326 1.99908 0.0654306 2.74914 0.00243482C3.4992 -0.060561 4.24551 0.160947 4.84001 0.623009C5.4345 1.08507 5.83374 1.75392 5.9585 2.49686H11V3.49774H10V5.49951H9V3.49774H8V5.49951H7V3.49774H5.9585ZM3 4.99907C3.53043 4.99907 4.03914 4.78817 4.41421 4.41276C4.78929 4.03736 5 3.5282 5 2.9973C5 2.4664 4.78929 1.95725 4.41421 1.58184C4.03914 1.20644 3.53043 0.99554 3 0.99554C2.46957 0.99554 1.96086 1.20644 1.58579 1.58184C1.21071 1.95725 1 2.4664 1 2.9973C1 3.5282 1.21071 4.03736 1.58579 4.41276C1.96086 4.78817 2.46957 4.99907 3 4.99907Z",
    fill: "#E4002B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.16442c1c96838cca7510c89a6183d656.svg";
export { ForwardRef as ReactComponent };